import {
  Divider,
  IconButton,
  InfoOutlinedIcon,
  PageHeader,
  PageLayout,
  Stack,
  SvgIcon,
  Tooltip,
} from '@cmg/design-system';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import ScreenHeader from '../../shared/layout/ScreenHeader';
import { ParticipationSetsDataGrid } from './components';

type Props = RouteComponentProps;

export const ManageParticipationSetsListRoute: React.FC<Props> = () => {
  return (
    <Stack flex={1} style={{ height: '100%' }}>
      <ScreenHeader />
      <PageLayout
        flex={1}
        header={
          <React.Fragment>
            <Divider />
            <PageHeader
              pageTitle={
                <React.Fragment>
                  Manage Investor Participation{' '}
                  <Tooltip
                    title="Offerings containing your private investor data.
To upload data, navigate to an offering profile and click 'Upload Participation Data'. Once the data is uploaded, you will be able to view details on this page and perform analytics on the data."
                  >
                    <IconButton>
                      <SvgIcon component={InfoOutlinedIcon} fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </React.Fragment>
              }
            />
            <Divider />
          </React.Fragment>
        }
      >
        <ParticipationSetsDataGrid />
      </PageLayout>
    </Stack>
  );
};
